import React, { useEffect, useState } from "react";

export function MeetingDetailsScreen({
  onClickJoin,
  participantName,
  setParticipantName,
}) {
  const [meetingId, setMeetingId] = useState("");
  const [meetingIdError, setMeetingIdError] = useState(false);
  const [meetingLocked, setMeetingLocked] = useState(false);

  // Prefill from URL params: sessionId, userName
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const sessionId = params.get("sessionId");
      const userName = params.get("userName");

      if (sessionId) {
        setMeetingId(sessionId);
        setMeetingLocked(true); // bloquear edición del Meeting ID
      }
      if (userName && typeof setParticipantName === "function") {
        setParticipantName(decodeURIComponent(userName));
      }
    } catch (e) {
      // ignore URL parsing issues
    }
  }, [setParticipantName]);

  return (
    <div
      className={`flex flex-1 flex-col justify-center w-full md:p-[6px] sm:p-1 p-1.5`}
    >
      {/* ID de la reunión */}
      <input
        value={meetingId}
        onChange={(e) => setMeetingId(e.target.value)}
        placeholder={"ID de la reunión"}
        className={`px-4 py-3 bg-gray-650 rounded-xl text-white w-full text-center ${
          meetingLocked ? "opacity-70 cursor-not-allowed" : ""
        }`}
        disabled={meetingLocked}
        readOnly={meetingLocked}
      />
      {meetingIdError && (
        <p className="text-xs text-red-600">{`Ingrese un ID de reunión válido`}</p>
      )}

      {/* Nombre */}
      <input
        value={participantName}
        onChange={(e) => setParticipantName(e.target.value)}
        placeholder="Su nombre"
        className="px-4 py-3 mt-5 bg-gray-650 rounded-xl text-white w-full text-center"
      />

      <button
        disabled={participantName.length < 3}
        className={`w-full ${
          participantName.length < 3 ? "bg-gray-650" : "bg-purple-350"
        }  text-white px-2 py-3 rounded-xl mt-5`}
        onClick={() => {
          if (meetingId.match("\\w{4}\\-\\w{4}\\-\\w{4}")) {
            onClickJoin(meetingId);
          } else setMeetingIdError(true);
        }}
      >
        Ingresar
      </button>
    </div>
  );
}
